module.exports = __webpack_public_path__ + "media/images/fleches dropdown-413b742ef4d9f12262fb1bc3af66319f.svg";